import { api } from "../../lib/api";
import { initials } from "./text";

/** A product's mark: its logo when it has one, else the prototype's initials tile (`.nwr`). */
export function ProductMark({ id, name, logo }: { id: string; name: string; logo: boolean }) {
  if (logo) return <img className="nwr pmark-img" src={api.products.logoUrl(id)} alt="" />;
  return <i className="nwr">{initials(name)}</i>;
}

const HUES = 4;

/** Which of the tile colours a product gets, the same every time. */
function hueOf(id: string): number {
  let h = 0;
  for (const c of id) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return h % HUES;
}

/**
 * A product's mark on a phone or an iPad: its logo, else its initials on a tile of its own colour, so two
 * products tell apart at a glance.
 */
export function ProductTile({ id, name, logo, size }: { id: string; name: string; logo: boolean; size: number }) {
  const box = { width: size, height: size, borderRadius: Math.round(size * 0.27) };
  if (logo) return <img className="pd-tile pd-tile-img" src={api.products.logoUrl(id)} alt="" style={box} />;
  const mono = initials(name);
  return (
    <span className={`pd-tile pd-hue${hueOf(id)}`} style={{ ...box, fontSize: Math.round(size * (mono.length > 1 ? 0.34 : 0.42)) }} aria-hidden="true">
      {mono}
    </span>
  );
}
